const mapEditorSectionToUrl = {
  landing: 'landing',
  survey: 'questions',
  images: 'images',
  // @todo rename to thank-you and survey @lukavyi
  ty: 'end',
  globalStyling: 'globalStyling',
  settings: 'settings',
  preview: 'preview',
  postSurveyLogic: 'postSurveyLogic',
  surveyEmbedding: 'embedding',
  media: 'media',
};

export default mapEditorSectionToUrl;
